import { Band as BandScale } from '@antv/scale';
export const Band = (options) => {
    return new BandScale(options);
};
Band.props = {};
//# sourceMappingURL=band.js.map